import { makeStyles } from '@fluentui/react-components';

export const useAssetStatusStyles = makeStyles({
  rejected: {
    color: '#A80000',
  },
});
